import {defineMessages} from "react-intl";

export default defineMessages({
  bugreport: {
    id: "bugreport.title"
  },
  button: {
    id: "bugreport.button"
  },
  copied: {
    id: "bugreport.copied"
  },
  copy: {
    id: "bugreport.copy"
  },
  description: {
    id: "bugreport.description"
  },
  mask: {
    id: "bugreport.mask"
  }
});



// WEBPACK FOOTER //
// ./src/components/UI/Utilities/Bugreport/translations.js